import PropTypes from 'prop-types'

import SearchField from '../../../FormLegacy/FormFieldsV2/SearchField'
import { sortOptions } from '../../helpers'
import Filter from '../../../../components/Filter/Filter'

const GroupSettingsToolbar = ({ search, setSearch, sortOrder, setSortOrder }) => {
  return (
    <div className="group-settings-toolbar">
      <div className="group-settings-toolbar__left">
        <div className="group-settings-toolbar__filters">
          <Filter
            placeholder={sortOrder ? sortOrder.text : 'Sort by'}
            options={sortOptions.filter((option) => option.id !== -1)}
            disabled={false}
            value={sortOrder ? [sortOrder] : []}
            name="GroupFilter"
            variant="borderless"
            onChange={(e) => setSortOrder(e.target.value)}
            closeAfterSelect
          />
        </div>
      </div>
      <div className="group-settings-toolbar__right">
        <div className="group-settings-toolbar__filters">
          <SearchField
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
    </div>
  )
}

GroupSettingsToolbar.propTypes = {
  search: PropTypes.string,
  setSearch: PropTypes.func,
  sortOrder: PropTypes.object,
  setSortOrder: PropTypes.func,
}

export default GroupSettingsToolbar
